import { cn } from '@/utils/cn'

import { Card, CardContent } from '../card'

interface Props {
    children: React.ReactNode
    className?: string
    title: string
    subTitle?: string
}

export default function FormBlock({ className, children, title, subTitle }: Props) {
    return (
        <div className={cn('mb-4 grid grid-cols-3 gap-4', className)}>
            <div>
                <h3 className="my-2">{title}</h3>
                {subTitle && <p className="text-sm text-muted-foreground">{subTitle}</p>}
            </div>

            <div className="col-span-2">
                <Card>
                    <CardContent className="pt-6">{children}</CardContent>
                </Card>
            </div>
        </div>
    )
}
